module.exports = __webpack_public_path__ + "assets/img/ubg.f48b43d4.png";